import { useState } from "react"

import style from "./style.module.scss"

import { Button, Column, Columns } from "ui-kit/components-branded/index"
import { HeaderTemplate } from "modules/ClientAccount"
import { HelpTooltip } from "components"
import { CURRENCY } from "utils/constants"
import { useGetCompanyInfo, useGetPeriod, useGetReport } from "modules/HRAccount/queries"
import { Layout } from "modules/HRAccount/Layout/Layout"
import { IndicatorCard } from "modules/HRAccount/IndicatorCard/IndicatorCard"
import { Divider } from "modules/HRAccount/Divider/Divider"
import { Aggregates } from "modules/HRAccount/Aggregates/Aggregates"
import { TopRequests } from "modules/HRAccount/TopRequests/TopRequests"
import { StatsTable } from "modules/HRAccount/StatsTable/StatsTable"
import {
    DefaultPeriod,
    FixedPeriod,
    initialPeriod,
    PeriodsDropdown,
} from "modules/HRAccount/PeriodsDropdown/PeriodsDropdown"
import { toQueryString } from "modules/HRAccount/utils"
import { AccountManagerInfo } from "modules/HRAccount/AccountManagerInfo/AccountManagerInfo"
import { REST_API_URL } from "utils/env-management"
import { formatPrice } from "utils/utils"

function download(period: DefaultPeriod | FixedPeriod) {
    window.location.assign(`${REST_API_URL}/company/report/download-xlsx${toQueryString(period)}`)
}

export function Statistics() {
    const [period, setPeriod] = useState<DefaultPeriod | FixedPeriod>(initialPeriod)
    const { data: companyInfo } = useGetCompanyInfo()
    const { data: availablePeriod } = useGetPeriod()
    const { data: statistics } = useGetReport(period)

    if (!companyInfo || !availablePeriod) return null

    return (
        <>
            <HeaderTemplate headline={companyInfo.title} />
            <Layout>
                <div>
                    <Columns className="has-small-gaps">
                        <Column>
                            <IndicatorCard
                                title={
                                    <IndicatorCard.Title className="mb-4">
                                        Баланс
                                    </IndicatorCard.Title>
                                }
                                value={
                                    <IndicatorCard.ValueBig isDanger>
                                        {formatPrice(companyInfo.balance, CURRENCY.RUB)}
                                    </IndicatorCard.ValueBig>
                                }
                                iconProps={{
                                    src: "credit-card-emoji.png",
                                    width: 18,
                                    height: 18,
                                }}
                            />
                        </Column>
                        {statistics && (
                            <Column>
                                <IndicatorCard
                                    title={
                                        <IndicatorCard.Title className="mb-4">
                                            <div className={style.header}>
                                                Прогноз расходов на&nbsp;месяц{" "}
                                                <HelpTooltip
                                                    iconWrapperClassName={style.icon}
                                                    overlay={
                                                        statistics.forecast ? (
                                                            <>
                                                                Прогноз расходов на&nbsp;текущий
                                                                месяц строится на&nbsp;основании
                                                                расходов за&nbsp;предыдущие месяцы
                                                                и&nbsp;может отличаться
                                                                от&nbsp;фактического расхода.
                                                            </>
                                                        ) : (
                                                            <>
                                                                Недостаточно данных для
                                                                осуществления расчетов. Прогноз
                                                                появится спустя 3&nbsp;месяца
                                                                с&nbsp;момента первой сессии
                                                                сотрудника.
                                                            </>
                                                        )
                                                    }
                                                />
                                            </div>
                                        </IndicatorCard.Title>
                                    }
                                    value={
                                        <IndicatorCard.ValueBig>
                                            {statistics.forecast
                                                ? formatPrice(statistics.forecast, CURRENCY.RUB)
                                                : "--"}
                                        </IndicatorCard.ValueBig>
                                    }
                                    iconProps={{
                                        src: "credit-card-emoji.png",
                                        width: 18,
                                        height: 18,
                                    }}
                                />
                            </Column>
                        )}
                    </Columns>
                </div>
                <Divider />
                {statistics && (
                    <Aggregates
                        statistics={statistics}
                        controls={
                            availablePeriod.hasData ? (
                                <div className="is-flex">
                                    <PeriodsDropdown
                                        period={period}
                                        onClick={(period) => {
                                            setPeriod(period)
                                        }}
                                        setInitialPeriod={() => setPeriod(initialPeriod)}
                                        startDate={availablePeriod.startDate}
                                    />
                                    <Button
                                        className="mgl-4 is-borderless"
                                        onClick={() => download(period)}
                                    >
                                        Скачать в&nbsp;.xls
                                    </Button>
                                </div>
                            ) : (
                                <></>
                            )
                        }
                    />
                )}
            </Layout>
            {statistics && (
                <Layout>
                    <StatsTable statisticByMonth={statistics.months} />
                </Layout>
            )}
            {statistics &&
                statistics.popular_requests.length > 0 &&
                statistics.popular_requests[0].requests.length > 0 && (
                    <Layout>
                        <TopRequests requests={statistics.popular_requests[0].requests} />
                    </Layout>
                )}
            <AccountManagerInfo />
        </>
    )
}
